/** Carta del coach al atleta: saludo, semana asignada y cómo usar las notas. */
export default function AthleteCoachWelcome({
  athleteName = '',
  coachName = '',
  days = [],
}) {
  const coach = String(coachName || '').trim() || 'tu entrenador';
  const athlete = String(athleteName || '').trim();
  const hello = athlete ? `Hola ${athlete}` : 'Hola';
  const soy = coach === 'tu entrenador' ? 'soy tu entrenador' : `soy ${coach}, tu entrenador`;

  return (
    <section
      className="rounded-2xl border border-violet-200 bg-violet-50 p-4 sm:p-5 mb-6 ui-light-panel surface-readable"
      aria-label="Mensaje de tu entrenador"
    >
      <p className="text-base sm:text-lg font-bold text-[#3b0764] m-0 leading-snug">
        {hello}, {soy}.
      </p>
      <p className="text-sm text-stone-800 mt-2 mb-0 leading-relaxed">
        Para esta semana esta es la rutina que te asigné, para que cumplamos nuestras metas.
        Entrenaremos así:
      </p>
      {days.length ? (
        <ul className="mt-3 mb-0 pl-0 list-none space-y-1.5">
          {days.map((row) => (
            <li key={row.dia} className="text-sm text-stone-900">
              <span className="font-semibold">{row.label}</span>
              {row.hasNotes ? (
                <span className="text-xs font-medium text-amber-900"> · te dejé notas</span>
              ) : null}
            </li>
          ))}
        </ul>
      ) : null}
      <p className="text-sm text-stone-800 mt-3 mb-0 leading-relaxed">
        En cada día te puedo guiar en las <strong>notas del entrenador</strong>: léelas antes de empezar.
        Después solo escribe lo que hiciste (km, tiempo o series) y guarda. Es fácil, vamos paso a paso.
      </p>
    </section>
  );
}
